<template>
    <div class="grid pb-0">
        <div class="grid-title">
            <h4 class="mr-auto">{{ $t("OVERVIEW") }}</h4>
            <!-- <v-row class="pr-3">
                <v-col class="text-right p-0">
                <v-btn class="mt-0 mr-2" :color="view == 'table' ? 'primary' : ''" @click="view = 'table'">
                    <v-icon light size="20px" left>table_chart</v-icon>
                    {{ $t("VIEW_TABLE") }}
                </v-btn>
                <v-btn class="" :color="view == 'calendar' ? 'primary' : ''" @click="getRateCalendar(true)">
                    <v-icon light size="20px" left>date_range</v-icon>
                    {{ $t("VIEW_CALENDAR") }}
                </v-btn>
                </v-col>
            </v-row> -->
        </div>
        <div class="grid-body border-top-unset" style="height: calc(100vh - 143px);">
            <div class="body-room-sale">
                <v-card-text>
                <v-row align="center">
                    <v-col sm="3" class="pt-0 pb-0">
                        <label>
                            {{ $t("ROOM_TYPE") }}
                        </label>
                        <treeselect :multiple="true" :options="listRoomTypeByRoomCategory"
                            :placeholder="$t('_BATCH_UPDATE.SELECT_ROOM_TYPE')" :limit="1"
                            :limitText="fnCount" v-model="selectedRoom">
                            <div slot="value-label" slot-scope="{ node }" class="text-truncate" style="max-width: 100px"
                            :title="node.raw.label">{{ node.raw.label }}</div>
                        </treeselect>
                    </v-col>
                    <v-col sm="3" class="pt-0 pb-0">
                        <label>
                            {{ $t("SALE_PACKAGE") }}
                        </label>
                        <treeselect :multiple="true" :options="listRatePlanByRateCategory" :placeholder="$t('SELECT_SALE_PACKAGE')"
                            :limit="1" :limitText="fnCount" v-model="selectedSalePackage">
                            <div slot="value-label" slot-scope="{ node }" class="text-truncate" style="max-width: 100px"
                            :title="node.raw.label">{{ node.raw.label }}</div>
                        </treeselect>
                    </v-col>
                    <v-col sm="3" class="pt-0 pb-0">
                        <label>
                            {{ $t("SALE_CHANNEL") }}
                        </label>
                        <v-autocomplete item-text="text" item-value="value" :items="listOTA" v-model="selectedOTA" outlined dense>
                            <template slot="no-data">
                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                            </template>
                        </v-autocomplete>
                    </v-col>
                    <v-col  class="d-flex justify-end align-items-end flex-wrap pb-0 h-100">
                        <div style="position: relative; top: 7px">
                            <v-btn color="primary" class="pl-5 pr-5" @click="getAll()">
                                <v-icon size="20" left>
                                search
                                </v-icon>
                                {{ $t("_BOOKING.SEARCH") }}
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>
                </v-card-text>
                <template>
                    <div v-if="isLoading == false" class="max-height-table" :style="{ 'max-height': maxHeight + 'px' }">
                        <table class="room-sale-table">
                        <tr>
                            <td class="table-left" style="width: 30%">
                            <table class="table-left-content">
                                <thead>
                                <tr>
                                    <th colspan="2">
                                    <div class="header-wrapper calendar">
                                        <v-icon light left color="#003e94" size="40" @click="prevMonth()">chevron_left</v-icon>
                                        <date-picker :model.sync="selectedDatePicker" :min="currentDatePicker" :max="maxDate"
                                        format="DD/MM/YYY" class="outlined" dense outlined />
                                        <v-icon light right color="#003e94" size="40" @click="nextMonth()">chevron_right</v-icon>
                                    </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(room, i) in relationData">
                                    <tr :key="i">
                                        <td class="room-row border-right" colspan="2">
                                            <div class=" px-2 d-flex justify-content-between border-0 text-nowrap align-items-center">
                                                <div class="font-weight-bold d-flex" :title="rooms.find(e => e.id == room.roomTypeId).label">
                                                    <div class=" text-truncate" style="max-width: 150px;">{{ rooms.find(e => e.id == room.roomTypeId).label }}
                                                    </div>
                                                    <div class="ml-2">({{ $t('HOTEL_LOG_id') }}: {{ room.roomTypeCode }})</div>
                                                </div>
                                            </div>
                                        </td>
                                        <!-- <td class="room-row border-right">
                                        </td> -->
                                    </tr>
                                    <template v-if="room.ratePlans.length > 0">
                                        <template v-for="(ratePlan, j1) in room.ratePlans" >
                                            <tr>
                                                <td :rowspan="2" class="border-right">
                                                    <div class="lh-13 px-2 d-flex justify-content-between border-0 align-items-center">
                                                        <div class="mr-auto">
                                                            <div class="d-flex txt-nowrap" :title="plans.find(e => e.id == ratePlan.ratePlanId).label">
                                                                <div class=" text-truncate" style="max-width: 150px;">{{ plans.find(e => e.id == ratePlan.ratePlanId).label }}
                                                                </div>
                                                                <div class="ml-2">({{ $t('HOTEL_LOG_id') }}: {{ ratePlan.ratePlanCode }})</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="border-right">
                                                    <div class="px-2 d-flex justify-content-between">
                                                    <span>
                                                        {{ $t("PRICE") }} ({{ currency }})
                                                    </span>
                                                    </div>
                                                </td>
                                            </tr>

                                            <tr>
                                                <td class="border-right">
                                                    <div class="px-2 d-flex justify-content-between text-nowrap">
                                                        <span>
                                                            {{
                                                                $t("closed")
                                                            }}
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </template>
                                    </template>
                                </template>
                                </tbody>
                            </table>
                            </td>
                            <td class="table-right">
                            <table class="table-right-content" style="display: revert;">
                                <thead>
                                <tr>
                                    <template v-for="(item, i) in dateList">
                                    <th :class="{ 'weekend-header': item.isWeekend }" class="border-right" style="width: 14.5% !important">
                                        <div class="header-wrapper border-0">
                                        <div class="date" v-html="formatDate(item.date)"></div>
                                        </div>
                                    </th>
                                    </template>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(room, i) in relationData">
                                    <tr>
                                        <td colspan="7" class="room-row border-right" >
                                            <!-- v-for="avail in dateList"
                                            :class="{ 'weekend-body': avail.isWeekend }" -->
                                        </td>
                                    </tr>
                                    <template v-if="room.ratePlans.length > 0">
                                    <template v-for="(ratePlan, j1) in room.ratePlans">
                                        <tr>
                                            <td class="border-right" v-for="(avail, index) in dateList" style="min-width: 144px;"
                                                :class="{ 'weekend-body': avail.isWeekend }">
                                                <template >
                                                <div class="body-wrapper">
                                                    <div class="border-0  px-2 text-center w-100 d-flex align-items-center justify-content-center">
                                                        <div v-if="ratePlan.rms.find(rms => rms.appliedDate == avail.date)" @click="detailRms(room, ratePlan, avail.date)" class="cursor">
                                                            <p class="text-smart font-weight-bold mb-0">
                                                                {{  numberFormat(ratePlan.rms.find(rms => rms.appliedDate == avail.date).priceAfterUpdate) }}
                                                            </p>
                                                            <p class="mb-0">
                                                                <span :class="ratePlan.rms.find(rms => rms.appliedDate == avail.date).currentOccupancy !== null ? '' : 'text-danger'"> 
                                                                    <i style="position: relative; top: 2px" class="fs-16 text-secondary" :class="ratePlan.rms.find(rms => rms.appliedDate == avail.date).appliedFor !== 'HOTEL' ? 'icon-bedroom_parent' : 'icon-Hotel'"></i>
                                                                {{ ratePlan.rms.find(rms => rms.appliedDate == avail.date).currentOccupancy !== null
                                                                ? ratePlan.rms.find(rms => rms.appliedDate == avail.date).currentOccupancy % 1 == 0 ? ratePlan.rms.find(rms => rms.appliedDate == avail.date).currentOccupancy + '% |' : ratePlan.rms.find(rms => rms.appliedDate == avail.date).currentOccupancy.toString().match(/^\d+\.\d{1,2}|^\d+$/)[0] + '% | '
                                                                : ratePlan.rms.find(rms => rms.appliedDate == avail.date).availability }}  </span> 
                                                                 <span v-if="ratePlan.rms.find(rms => rms.appliedDate == avail.date).currentOccupancy !== null">
                                                                    <span class="text-success">{{ ratePlan.rms.find(rms => rms.appliedDate == avail.date).reservedInventory}}</span>
                                                                    | <span class="text-primary">{{ ratePlan.rms.find(rms => rms.appliedDate == avail.date).dayUseInventory}}</span>
                                                                    | <span class="text-danger">{{ ratePlan.rms.find(rms => rms.appliedDate == avail.date).availability}}</span>
                                                                    
                                                                 </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                </template>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="border-right text-center" v-for="(appliedDate, ind) in dateList"
                                            :class="{ 'weekend-body': appliedDate.isWeekend }" :key="ind">
                                                <template v-if="stopSellData.find(st => st.roomTypeId == room.roomTypeId)">
                                                    <template v-if="stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId)">
                                                        <template v-if="stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date)">
                                                            <div class="body-wrapper" @click="detailRmsStopSell(room, ratePlan, appliedDate.date)">
                                                                <div class="border-0  px-2"
                                                                    :class="stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).restrictionAfterUpdate  === 'true' ? 'vertical-divider closed' : 'vertical-divider'">
                                                                    <div>
                                                                        <template
                                                                            v-if="stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).restrictionAfterUpdate === 'true'">
                                                                            <i class="icon-Exit text-danger fs-18 font-weight-bold" style="position: relative; top: 5px;"></i>
                                                                        </template>

                                                                        <template
                                                                            v-else-if="stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).restrictionAfterUpdate === 'false'">
                                                                            <i class="icon-check text-success fs-16 font-weight-bold" style="position: relative; top: 5px;"></i>
                                                                        </template>
                                                                        <p class="mb-0">
                                                                            <span class="p-0" :class="stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).currentOccupancy !== null ? '' : 'text-danger'"> 
                                                                                <i style="position: relative; top: 2px" class="fs-16 text-secondary" :class="stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).appliedFor !== 'HOTEL' ? 'icon-bedroom_parent' : 'icon-Hotel'"></i>
                                                                            {{ stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).currentOccupancy !== null
                                                                            ? stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).currentOccupancy % 1 == 0 ? stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).currentOccupancy + '% |' : stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).currentOccupancy.toString().match(/^\d+\.\d{1,2}|^\d+$/)[0] + '% | '
                                                                            : stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).availability }}  </span> 
                                                                            <span class="p-0" v-if="stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).currentOccupancy !== null">
                                                                                <span class="text-success p-0">{{ stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).reservedInventory}}</span>
                                                                                | <span class="text-primary p-0">{{ stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).dayUseInventory}}</span>
                                                                                | <span class="text-danger p-0">{{ stopSellData.find(st => st.roomTypeId == room.roomTypeId).ratePlans.find(rp => rp.ratePlanId === ratePlan.ratePlanId).rms.find(rms => rms.appliedDate === appliedDate.date).availability}}</span>
                                                                                
                                                                            </span>
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </template>
                                                </template>
                                            </td>
                                        </tr>
                                    </template>
                                    </template>
                                </template>
                                </tbody>
                            </table>
                            </td>
                        </tr>
                        </table>
                        <v-btn v-if="!isNote" color="primary" dark bottom left class="btn-note"
                        @click="isNote = true; maxHeight = maxHeight - 60">
                        <i class="icon-category fs-16"></i>
                        </v-btn>
                    </div>
                    <div class="text-center" v-if="isLoading">
                        <img src="@/assets/loading-logo-animation.gif" style="width: 75px" />

                        <p class="font-weight-bold">{{ $t('THE_SYSTEM_IS_LOADING') }}</p>
                    </div>
                    <v-col class="border-top d-flex align-items-center" v-if="isNote" style="position: absolute; bottom: 0;     background: #fff;
                                        z-index: 9;">
                        <ul class="tools-icon-description">
                            <li>
                                <i style="position: relative; top: 2px" class="fs-16 text-secondary icon-bedroom_parent"></i>
                                {{ $t("BY_ROOM") }}
                            </li>
                            <li>
                                <i style="position: relative; top: 2px" class="fs-16 text-secondary icon-Hotel"></i>
                                {{ $t("BY_HOTEL") }}
                            </li>
                            <li style="position: relative; top: 2px">
                                <span class="font-weight-bold">000%</span>
                                {{ $t("INDEX_P") }}
                            </li>
                            <li style="position: relative; top: 2px">
                                <span class="font-weight-bold text-success">000</span>
                                {{ $t("INDEX_A") }}
                            </li>
                            <li style="position: relative; top: 2px">
                                <span class="font-weight-bold text-primary">000</span>
                                {{ $t("INDEX_DU") }}
                            </li>
                            <li style="position: relative; top: 2px">
                                <span class="font-weight-bold text-danger">000</span>
                                {{ $t("INDEX_B") }}
                            </li>

                            
                            <li style="position: relative; top: 2px">
                                <span class="text-smart font-weight-bold">000</span>
                                {{ $t("DYNAMIC_PRICING") }}
                            </li>
                            <li >
                                <i class="icon-check text-success fs-16 font-weight-bold" style="position: relative; top: 3px;"></i>
                                {{ $t("UN_STOP_SELL") }}
                            </li>
                            <li style="position: relative; top: 2px">
                                <span class="i-square bg-stopSell"><i class="icon-Exit text-danger fs-18 font-weight-bold" style="position: relative; top: -3px; left: 2px"></i></span>
                                {{ $t("closed") }}
                            </li>
                        </ul>
                        <!-- <v-btn class="ml-3 py-5" dark small color="primary" @click="isNote = false; maxHeight = maxHeight + 60">
                        <i class="icon-expand_more fs-16"></i>
                        </v-btn> -->
                    </v-col>
                </template>
            </div>
        </div>
        <v-dialog v-if="isLoading == false" v-model="isDetail" width="950"
          class="modal-quick-edit">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title >
              <strong> <span class="text-primary fs-14">{{ $t("DETAIL") }}</span> 
              <span v-if="productDetail">: {{ _moment(new Date(productDetail.appliedDate)).format("DD/MM/YYYY")  }}</span>
                </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                icon
                dark
                @click="isDetail = false"
            >
                <v-icon color="primary">mdi-close</v-icon>
            </v-btn> 
          </v-toolbar>
          <div class="content-update" v-if="!isLoadingDetail && isDetail">
            <p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
            $t("BOOKING_CHANNEL") }}:</span> {{ listOTA.find(e => e.value == productDetail.otaId).text }}</label></p>
            <p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
            $t("_ROOM_SALE.ROOM_TYPE.ROOM_TYPE") }}:</span>  {{ rooms.find(e => e.id == productDetail.roomTypeId).label }} </label></p>
            <p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
            $t("_SALE_PACKAGE.SALE_PACKAGE") }}:</span> {{ plans.find(e => e.id == productDetail.ratePlanId).label }}</label></p>
            <v-data-table :headers="headers" :items="detailData" :single-select="false" :items-per-page="detailData.length" hide-default-footer class="table-booking elevation-1" fixed-header height="300px"
                :no-data-text="$t('NO_RECORDS')">    
                <template v-slot:item.index="{ item, index }">{{ index + 1 }}</template>
                <template v-slot:item.priceAfterUpdate="{ item }">{{  numberFormat(item.priceAfterUpdate) }}</template>
                <template v-slot:item.appliedFor="{ item }">
                    <span class="text-nowrap"> {{ item.appliedFor !== 'HOTEL' ? $t('ACCORDING_TO_EACH_ROOM_CLASS') : $t('ENTIRE_HOTEL') }}</span>
                </template>
                <template v-slot:item.createdDate="{ item }">
                    {{utcConvertToLocalTimeZone(item.createdDate)}}
                </template>
                <template v-slot:item.currentOccupancy="{ item }">
                    {{ item.currentOccupancy !== null ? item.currentOccupancy % 1 == 0 ? item.currentOccupancy + '%' : item.currentOccupancy.toString().match(/^\d+\.\d{1,2}|^\d+$/)[0] + '% ' : "" }}
                </template>
                <template v-slot:item.reservedInventory="{ item }">
                    <a @click="openPopupA(item)" class="text-decoration-underline">
                        {{item.reservedInventory}} 
                    </a>
                </template>
                <template v-slot:item.dayUseInventory="{ item }">
                    <a @click="openPopupDU(item)" class="text-decoration-underline">
                        {{item.dayUseInventory}}
                    </a>
                </template>
            </v-data-table>
          </div>
        </v-dialog>
        <v-dialog v-if="isLoading == false" v-model="isDetailStopSell" width="950"
          class="modal-quick-edit">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title >
              <strong> <span class="text-primary fs-14">{{ $t("DETAIL") }}</span> 
              <span v-if="productDetail">: {{ _moment(new Date(productDetail.appliedDate)).format("DD/MM/YYYY")  }}</span>
                </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                icon
                dark
                @click="isDetailStopSell = false"
            >
                <v-icon color="primary">mdi-close</v-icon>
            </v-btn> 
          </v-toolbar>
          <div class="content-update" v-if="!isLoadingDetail && isDetailStopSell">
            <p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
            $t("BOOKING_CHANNEL") }}:</span> {{ listOTA.find(e => e.value == productDetail.otaId).text }}</label></p>
            <p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
            $t("_ROOM_SALE.ROOM_TYPE.ROOM_TYPE") }}:</span>  {{ rooms.find(e => e.id == productDetail.roomTypeId).label }} </label></p>
            <p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
            $t("_SALE_PACKAGE.SALE_PACKAGE") }}:</span> {{ plans.find(e => e.id == productDetail.ratePlanId).label }}</label></p>
            <v-data-table :headers="headersStopSell" :items="detailDataStopSell" :items-per-page="detailDataStopSell.length" :single-select="false" hide-default-footer class="table-booking" fixed-header 
                :no-data-text="$t('NO_RECORDS')" height="300px">    
                <template v-slot:item.index="{ item, index }">{{ index + 1 }}</template>
                <template v-slot:item.priceAfterUpdate="{ item }">{{  numberFormat(item.priceAfterUpdate) }}</template>
                <template v-slot:item.appliedFor="{ item }">
                   <span class="text-nowrap"> {{ item.appliedFor !== 'HOTEL' ? $t('ACCORDING_TO_EACH_ROOM_CLASS') : $t('ENTIRE_HOTEL') }}</span>
                </template>
                <template v-slot:item.createdDate="{ item }">
                    {{utcConvertToLocalTimeZone(item.createdDate)}}
                </template>
                <template v-slot:item.currentOccupancy="{ item }">
                    {{ item.currentOccupancy !== null ? item.currentOccupancy % 1 == 0 ? item.currentOccupancy + '%' : item.currentOccupancy.toString().match(/^\d+\.\d{1,2}|^\d+$/)[0] + '% ' : "" }}
                </template>
                <template v-slot:item.reservedInventory="{ item }">
                    <a @click="openPopupAStopSell(item)" class="text-decoration-underline">
                        {{item.reservedInventory}} 
                    </a>
                </template>
                <template v-slot:item.dayUseInventory="{ item }">
                    <a @click="openPopupDUStopSell(item)" class="text-decoration-underline">
                        {{item.dayUseInventory}}
                    </a>
                </template>
                <template v-slot:item.restrictionAfterUpdate="{ item }">
                    <span class="text-danger" v-if="item.restrictionAfterUpdate == 'true'">{{  $t('closed') }}</span>
                    <span class="text-success" v-if="item.restrictionAfterUpdate == 'false'">{{  $t('UN_STOP_SELL') }}</span>
                </template>
            </v-data-table>
          </div>
        </v-dialog>
        <v-dialog v-if="isLoading == false" v-model="isDetailADU" width="950"
          class="modal-quick-edit">
          <v-toolbar class="toolbar-update" dense>
            <v-toolbar-title >
              <strong> <span class="text-primary fs-14">{{ $t("DETAIL") }}</span> 
              <span v-if="detailType">: {{  detailType.type }}</span>
                </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
                icon
                dark
                @click="isDetailADU = false; closePopup()"
            >
                <v-icon color="primary">mdi-close</v-icon>
            </v-btn>                      
          </v-toolbar>
          <div class="content-update" v-if="!isLoadingDetailType">
            <div class="d-flex">
                <div class="w-50">
                    <p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
                    $t("BOOKING_CHANNEL") }}:</span> {{ listOTA.find(e => e.value == detailType.otaId).text }}</label></p>
                    <p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
                    $t("_ROOM_SALE.ROOM_TYPE.ROOM_TYPE") }}:</span>  {{ rooms.find(e => e.id == detailType.roomTypeId).label }} </label></p>
                    <p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
                    $t("_SALE_PACKAGE.SALE_PACKAGE") }}:</span> {{ plans.find(e => e.id == detailType.ratePlanId).label }}</label></p>
                </div>
                <div>
                    <p class="mb-0"><label class="s-label"><span class="font-weight-bold">{{
                    $t("UPDATE_TIME") }}:</span> {{utcConvertToLocalTimeZone(detailType.createdDate)}}</label></p>
                </div>
            </div>
            <v-data-table :headers="headersDetailType" :items="detailType.data" :items-per-page="detailType.data.length" :single-select="false" hide-default-footer class="table-booking" fixed-header
                :no-data-text="$t('NO_RECORDS')" height="300px">    
                <template v-slot:item.index="{ item, index }">{{ index + 1 }}</template>
                <template v-slot:item.priceAfterUpdate="{ item }">{{  numberFormat(item.priceAfterUpdate) }}</template>
                <template v-slot:item.arrival="{ item }">
                    <template v-if="item.arrival && item.departure">
                    {{
                        _formatDateTime(
                        item.arrival,
                        "YYYY-MM-DD",
                        systemLang == 'vi' ? "DD/MM/YYYY" : "YYYY/MM/DD"
                        ) +
                        " - " +
                        _formatDateTime(
                        item.departure,
                        "YYYY-MM-DD",
                        systemLang == 'vi' ? "DD/MM/YYYY" : "YYYY/MM/DD"
                        )
                    }}
                    </template>
                    <template v-else>N/A</template>
                </template>
                <template v-slot:item.createdDate="{ item }">
                    {{utcConvertToLocalTimeZone(item.createdDate)}}
                </template>
                <template v-slot:item.bookingStatus="{ item }">
                    <span :style="{ color: listBookingStatus.find(x => x.value == item.bookingStatus).color }">
                        {{
                            listBookingStatus.find(x => x.value == item.bookingStatus).text
                        }}
                    </span>
                </template>
            </v-data-table>
          </div>
        </v-dialog>
    </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { sale_room } from "@/_services/SaleRoom/sale-room.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import moment from "moment";
export default {
    components: {
        "date-picker": () => import('@/components/Utils/DatePicker.vue'),
        Treeselect
    },
    data() {
        return {
            maxHeight: 430,
            systemLang: this.$i18n.locale,
            listRoomTypeByRoomCategory: [],
            listRoomCategory: [],
            selectedRoom: [],

            listRateCategory: [],
            selectedRateCategory: [],
            listRatePlanByRateCategory: [],
            selectedSalePackage: [],

            listOTA: [],
            selectedOTA: null,

            isLoading: true,
            relationData: null,
            isNote: true,
            weekend: ["WED", "THU", "FRI", "SAT", "SUN", "TUE", "MON"],
            defaultWeekend: [],
            dateList: [],
            currentDate: moment()
                .startOf("day")
                .toDate(),
            maxDate: moment(this.currentDate)
                .add(2, "year")
                .add(14, "day")
                .format("YYYY-MM-DD"),
            rooms: [],
            plans: [],
            currency: null,
            selectedDatePicker: moment()
            .startOf("day")
            .format("YYYY-MM-DD"),
            isDetail: false,
            detailData: [],
            productDetail: null,
            stopSellData: [],
            isLoadingDetail: true,
            detailDataStopSell: [],
            isDetailStopSell: false,
            detailType: null,
            isLoadingDetailType: true,
            isDetailADU: false,
            listBookingStatus: [
                // {
                //   value: null,
                //   text: this.$t("ALL"),
                //   color: "primary",
                //   colorText: 'text-white'
                // },
                {
                value: 0,
                text: this.$t("_BOOKING.STATUS.AWAIT_PAYMENT"),
                color: "rgb(254, 209, 47)",
                bg: "rgba(253, 185, 19, 0.12)",
                colorText: 'text-white'
                },
                {
                value: 1,
                text: this.$t("_BOOKING.STATUS.CONFIRM"),
                color: "#0da313",
                colorText: 'text-white'
                },
                {
                value: 2,
                text: this.$t("_BOOKING.STATUS.CANCEL"),
                color: "#808080",
                bg: "rgba(128, 128, 128, 0.12)",
                colorText: 'text-white'
                },
                {
                value: 3,
                text: this.$t("_BOOKING.STATUS.VOID"),
                color: "#D20000",
                bg: "rgba(38, 38, 38, 0.12)",
                colorText: 'text-white'
                },
                {
                value: 4,
                text: this.$t("_BOOKING.STATUS.IN_SERVICE"),
                color: "#262626",
                bg: "rgba(38, 38, 38, 0.12)",
                colorText: 'text-white'
                },
                {
                value: 5,
                text: this.$t("_BOOKING.STATUS.CLOSE"),
                color: "#262626",
                bg: "rgba(38, 38, 38, 0.12)",
                colorText: 'text-white'
                },
                {
                value: 6,
                text: this.$t("_BOOKING.STATUS.PAYMENT_FAILED"),
                color: "#ff0000",
                bg: "rgba(255, 0, 0, 0.12)",
                colorText: 'text-white'
                },
                {
                value: 7,
                text: this.$t("_BOOKING.STATUS.AWAIT_FULLY_PAYMENT"),
                color: "#fed12f",
                bg: "rgba(254, 209, 47, 0.12)",
                colorText: 'text-white'
                },
            ],
            typePopup: null,
        };
    },
    created() {
        this.currency = this.usedCurrency;
        this.maxHeight = window.innerHeight - 50 - 68 - 46 - 75 - 60 + 15 - 20;
        this.getAllRoomByRoomCategory();
    },
    watch: {
        selectedDatePicker() {
            this.currentDate = this.selectedDatePicker;
        },
    },
    methods: {
        _moment: moment,
        _formatDateTime(value, inputFormat, outputFormat) {
            if (!value) {
                return "";
            }
            return moment(value).format(outputFormat);
        },
        closePopup() {
            if (this.typePopup === 'PRICE') {
                this.isDetail = true;
            } else {
                this.isDetailStopSell = true;
            }
        },
        openPopupA(item) {
            this.detailType = item;
            this.detailType.type = 'A';
            this.isLoadingDetailType = true;
            this.typePopup = 'PRICE';
            let body = {
                appliedDate: item.appliedDate,
                processTrackingId: item.processTrackingId,
                // otaId: this.selectedOTA,
                roomTypeId: item.roomTypeId
            };
            sale_room
                .dashboardRmsDetailDayA(body)
                .then((res) => {
                    this.detailType.data = res.data;
                    this.isLoadingDetailType = false;
                    this.isDetail = false;
                    this.isDetailADU = true;
                    
                })
                
        },
        openPopupDU(item) {
            this.detailType = item;
            this.detailType.type = 'DU';
            this.isLoadingDetailType = true;
            this.typePopup = 'PRICE';
            let body = {
                appliedDate: item.appliedDate,
                processTrackingId: item.processTrackingId,
                // otaId: this.selectedOTA,
                roomTypeId: item.roomTypeId
            };
            sale_room
                .dashboardRmsDetailDayDU(body)
                .then((res) => {
                    this.detailType.data = res.data;
                    this.isLoadingDetailType = false;
                    this.isDetail = false;
                    this.isDetailADU = true;
                    
                })
                
        },
        openPopupAStopSell(item) {
            this.detailType = item;
            this.detailType.type = 'A';
            this.isLoadingDetailType = true;
            this.typePopup = 'STOP_SELL';
            let body = {
                appliedDate: item.appliedDate,
                processTrackingId: item.processTrackingId,
                // otaId: this.selectedOTA,
                roomTypeId: item.roomTypeId
            };
            sale_room
                .dashboardRmsDetailDayA(body)
                .then((res) => {
                    this.detailType.data = res.data;
                    this.isLoadingDetailType = false;
                    this.isDetailStopSell = false;
                    this.isDetailADU = true;
                    
                })
                
        },
        openPopupDUStopSell(item) {
            this.detailType = item;
            this.detailType.type = 'DU';
            this.isLoadingDetailType = true;
            this.typePopup = 'STOP_SELL';
            let body = {
                appliedDate: item.appliedDate,
                processTrackingId: item.processTrackingId,
                // otaId: this.selectedOTA,
                roomTypeId: item.roomTypeId
            };
            sale_room
                .dashboardRmsDetailDayDU(body)
                .then((res) => {
                    this.detailType.data = res.data;
                    this.isLoadingDetailType = false;
                    this.isDetailStopSell = false;
                    this.isDetailADU = true;
                    
                })
                
        },
        numberFormat(x) {
            if (x !== null) {
                return new Intl.NumberFormat(this.systemLang, {
                    style: 'decimal',
                    minimumFractionDigits: this.usedCurrency == 'VND' ? 0 : 2,
                    maximumFractionDigits: this.usedCurrency == 'VND' ? 0 : 2,
                }).format(x)
            }
        },
        onResize() {
            this.maxHeight = window.innerHeight - 60 - 68 - 46 - 16 - 70 - 60;
        },
        formatDate(date) {
            var currentDate = moment(date, "YYYY-MM-DD");
            if (!currentDate.isValid()) {
                return "";
            }
            let dayOfWeek = "";
            switch (currentDate.day()) {
                case 0: {
                    dayOfWeek = this.$t("SUN_SHORT").toString();
                    break;
                }
                case 1: {
                    dayOfWeek = this.$t("MON_SHORT").toString();
                    break;
                }
                case 2: {
                    dayOfWeek = this.$t("TUE_SHORT").toString();
                    break;
                }
                case 3: {
                    dayOfWeek = this.$t("WED_SHORT").toString();
                    break;
                }
                case 4: {
                    dayOfWeek = this.$t("THU_SHORT").toString();
                    break;
                }
                case 5: {
                    dayOfWeek = this.$t("FRI_SHORT").toString();
                    break;
                }
                case 6: {
                    dayOfWeek = this.$t("SAT_SHORT").toString();
                    break;
                }
            }
            return (
                '<div class="day-week">' +
                dayOfWeek +
                '</div><div class="day-day font-weight-bold">' +
                currentDate.format("DD") +
                '</div><div class="day-month">' +
                this.$t(currentDate.format("MMM").toUpperCase() + "_SHORT") +
                "</div>"
            );
        },
        loadDateList() {
            let hotelWeekend = JSON.parse(localStorage.getItem("hotelWeekend"));
            // Chuyển từ binary sang select
            this.defaultWeekend = this.convertFromBinaryToListSelection(hotelWeekend);
            var tmp = [];
            this.defaultWeekend.forEach(function (element, index) {
                if (element == 1) {
                if (index == 0) {
                    tmp.push("MON");
                }
                if (index == 1) {
                    tmp.push("TUE");
                }
                if (index == 2) {
                    tmp.push("WED");
                }
                if (index == 3) {
                    tmp.push("THU");
                }
                if (index == 4) {
                    tmp.push("FRI");
                }
                if (index == 5) {
                    tmp.push("SAT");
                }
                if (index == 6) {
                    tmp.push("SUN");
                }
                }
            });
            this.weekend = tmp
            var currentDate = moment(this.currentDate);
            this.dateList = [];
            for (let i = 0; i < 7; i++) {
                var isWeekend =
                tmp.indexOf(currentDate.format("ddd").toUpperCase()) > -1;
                this.dateList.push({
                    date: currentDate.format("YYYY-MM-DD"),
                    isWeekend: isWeekend
                });
                currentDate.add(1, "day");
            }
        },
        convertFromBinaryToListSelection(number) {
            let output = parseInt(number, 10).toString(2);
            while (output.length < 7) {
                output = "0" + output;
            }
            return output.split("");
        },
        getAllRoomByRoomCategory() {
            this.rooms = [];
            sale_room
                .getAllRoomTypeByCategory()
                .then((res) => {
                this.listRoomCategory = res.data.map(x => x.roomCategoryId);
                const data = [];
                res.data.forEach(e => {
                    if (e.roomTypes.length > 0) {
                        e.roomTypes.forEach(rt => {
                            this.rooms.push({
                                id: rt.id,
                                label: rt.roomTypeI18n.find(l => l.lang === this.defaultI18n) ? rt.roomTypeI18n.find(l => l.lang === this.defaultI18n).name : rt.nameVi,
                            })
                        });
                        data.push({
                            id: e.roomCategoryId ? e.roomCategoryId : -1,
                            label: e.roomCategoryI18ns.find(l => l.lang === this.defaultI18n) ? e.roomCategoryI18ns.find(l => l.lang === this.defaultI18n).name : e.nameVi,
                            children: e.roomTypes.map(pl => Object.assign({}, {
                                id: pl.id,
                                label: pl.roomTypeI18n.find(l => l.lang === this.defaultI18n) ? pl.roomTypeI18n.find(l => l.lang === this.defaultI18n).name : pl.nameVi,
                            }))
                        });
                    }
                })
                this.listRoomTypeByRoomCategory = [...data];
                this.selectedRoom = this.listRoomTypeByRoomCategory.map(e => e.id);
                this.getAllPlanByRateCategory();
            })
        },
        getAllPlanByRateCategory() {
            this.plans = [];
            sale_room
            .getAllRatePlanByCategory()
                .then((res) => {
                    this.listRateCategory = res.data.map(x => x.rateCategoryId);
                    const data = [];
                    res.data.forEach(e => {
                        if (e.ratePlans.length > 0) {
                            e.ratePlans.forEach(rt => {
                                this.plans.push({
                                    id: rt.id,
                                    label: rt.ratePlanI18n.find(l => l.lang === this.defaultI18n) ? rt.ratePlanI18n.find(l => l.lang === this.defaultI18n).name : rt.nameVi,
                                })
                            });
                            data.push({
                                id: e.rateCategoryId ? e.rateCategoryId : -1,
                                label: e.rateCategoryI18ns.find(l => l.lang === this.defaultI18n) ? e.rateCategoryI18ns.find(l => l.lang === this.defaultI18n).name : e.nameVi,
                                children: e.ratePlans.map(pl => Object.assign({}, {
                                    id: pl.id,
                                    label: pl.ratePlanI18n.find(l => l.lang === this.defaultI18n) ? pl.ratePlanI18n.find(l => l.lang === this.defaultI18n).name : pl.nameVi,
                                }))
                            });
                        }
                    })
                this.listRatePlanByRateCategory = [...data];
                this.selectedSalePackage = this.listRatePlanByRateCategory.map(e => e.id);
                this.getOta();
            })
        },
        nextMonth() {
            this.selectedDatePicker = moment(this.selectedDatePicker)
                .add(7, "day")
                .format("YYYY-MM-DD");
            this.getAll();
        },
        prevMonth() {
            this.selectedDatePicker = moment(this.selectedDatePicker)
                .add(-7, "day")
                .format("YYYY-MM-DD");

            if (
                this.selectedDatePicker <
                moment()
                .startOf("day")
                .format("YYYY-MM-DD")
            ) {
                this.selectedDatePicker = moment()
                .startOf("day")
                .format("YYYY-MM-DD");
            }

            this.getAll();
        },
        async getOta() {
            await syncota.getAllOTA({ keyword: "", status: 1 }).then(res => {
                if (res.responseCode === 0) {
                    this.listOTA = res.data.map(x => {
                        return {
                            value: x.id,
                            text: x.otaI18n.find(y => y.lang == this.defaultI18n).name,
                            code: x.otaCode
                        };
                    });
                    this.listOTA = this.listOTA.filter(x => x.value);
                    this.listOTA.sort((a, b) => a.text.localeCompare(b.text));
                    this.selectedOTA = this.listOTA[0].value;
                    this.getAll()
                }
            });
        },
        getAll() {
            this.isLoading = true;
            var ratePlanIds = [];
            this.selectedSalePackage.forEach(e => {
                if (this.listRateCategory.includes(e) || e == -1) {
                var arrPlanIds = this.listRatePlanByRateCategory.find(item => item.id === e).children.map(c => c.id);
                ratePlanIds = ratePlanIds.concat(arrPlanIds)
                } else {
                ratePlanIds.push(e)
                }
            });
            var roomTypeIds = [];
            this.selectedRoom.forEach(e => {
                if (this.listRoomCategory.includes(e) || e == -1) {
                var arrRoomIds = this.listRoomTypeByRoomCategory.find(item => item.id === e).children.map(c => c.id);
                roomTypeIds = roomTypeIds.concat(arrRoomIds)
                } else {
                roomTypeIds.push(e)
                }
            });
            var fromDate = this.selectedDatePicker;
            var toDate = moment(this.selectedDatePicker)
                .add(7, "day")
                .format("YYYY-MM-DD");
            let body = {
                startDate: fromDate,
                endDate: toDate,
                roomTypeIds: roomTypeIds.length > 0 ? [...roomTypeIds] : [],
                ratePlanIds: ratePlanIds.length > 0 ? [...ratePlanIds] : [],
                otaId: this.selectedOTA,
            };
            sale_room
                .dashboardRms(body)
                .then((res) => {
                    this.relationData = res.data;
                    this.getStopSell(body);
                })
        },
        getStopSell(body) {
            sale_room
                .dashboardRmsStopSell(body)
                .then((res) => {
                    this.stopSellData = res.data;
                    this.loadDateList();
                    this.isLoading = false;
                })
        },
        detailRms(room, plan, date) {
            this.isLoadingDetail = true;
            this.isDetail = true;
            let body = {
                appliedDate: date,
                roomTypeId: room.roomTypeId,
                ratePlanId: plan.ratePlanId,
                otaId: this.selectedOTA,
            };
            this.productDetail = body;
            sale_room
                .dashboardRmsDetailDay(body)
                .then((res) => {
                    this.detailData = res.data;
                    this.isLoadingDetail = false;
                })
        },
        detailRmsStopSell(room, plan, date) {
            this.isLoadingDetail = true;
            this.isDetailStopSell = true;
            let body = {
                appliedDate: date,
                roomTypeId: room.roomTypeId,
                ratePlanId: plan.ratePlanId,
                otaId: this.selectedOTA,
            };
            this.productDetail = body;
            sale_room
                .detailRmsStopSell(body)
                .then((res) => {
                    this.detailDataStopSell = res.data;
                    this.isLoadingDetail = false;
                    
                })
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t("STT"),
                    align: 'center',
                    value: 'index',
                    sortable: false
                },
                {
                    text: this.$t("UPDATE_TIME"),
                    value: "createdDate",
                    sortable: false
                },
                {
                    text: this.$t("_BATCH_UPDATE.PRICE"),
                    value: "priceAfterUpdate",
                    align: 'end',
                    sortable: false
                },
                {
                    text: this.$t("APPLY_FOR"),
                    value: "appliedFor",
                    sortable: false
                },
                {
                    text: 'P',
                    value: "currentOccupancy",
                    align: 'end',
                    sortable: false,
                    width: "45px"
                },
                {
                    text: 'A',
                    value: "reservedInventory",
                    align: 'end',
                    sortable: false,
                    width: "45px"
                },
                {
                    text: 'DU',
                    value: "dayUseInventory",
                    align: 'end',
                    sortable: false,
                    width: "45px"
                },
                {
                    text: 'B',
                    value: "availability",
                    align: 'end',
                    sortable: false,
                    width: "45px"
                },
            ];
        },
        headersStopSell() {
            return [
                {
                    text: this.$t("STT"),
                    align: 'center',
                    value: 'index',
                    sortable: false
                },
                {
                    text: this.$t("UPDATE_TIME"),
                    value: "createdDate",
                    sortable: false
                },
                {
                    text: this.$t("closed"),
                    value: "restrictionAfterUpdate",
                    sortable: false
                },
                {
                    text: this.$t("APPLY_FOR"),
                    value: "appliedFor",
                    sortable: false
                },
                {
                    text: 'P',
                    value: "currentOccupancy",
                    align: 'end',
                    sortable: false,
                    width: "45px"
                },
                {
                    text: "A",
                    value: "reservedInventory",
                    align: 'end',
                    sortable: false,
                    width: "45px"
                },
                {
                    text: 'DU',
                    value: "dayUseInventory",
                    align: 'end',
                    sortable: false,
                    width: "45px"
                },
                {
                    text: 'B',
                    value: "availability",
                    align: 'end',
                    sortable: false,
                    width: "45px"
                }
            ];
        },
        headersDetailType() {
            return [
                {
                    text: this.$t("STT"),
                    align: 'center',
                    value: 'index',
                    sortable: false
                },
                {
                    text: this.$t("_BOOKING.BOOKING_CODE"),
                    value: "bookingCode",
                    sortable: false
                },
                {
                    text: this.$t("_BOOKING.TIME_STAY"),
                    value: "arrival",
                    sortable: false
                },
                {
                    text: this.$t("_BOOKING.BOOKING_STATUS"),
                    value: "bookingStatus",
                    sortable: false,
                    align: 'center',
                },
                {
                    text: this.$t("_BOOKING_DETAIL.SERVICE.COUNT"),
                    value: "quantity",
                    align: 'end',
                    sortable: false,
                    width: "45px"
                },
                {
                    text: this.$t("_BOOKING_DETAIL.BOOKING_DETAIL.CREATED"),
                    value: "createdDate",
                    align: 'end',
                    sortable: false,
                }
            ];
        },
    },  
}
</script>